import { client } from '../client';
import { PaymentProfile } from './types/PaymentProfile';
import { UserRoleName } from './types/UserProfile';

export const addPaymentProfile = async (payload: PaymentProfile, userRole?: string): Promise<PaymentProfile> => {
  const path =
    userRole === UserRoleName.CareAdvisor
      ? '/care_advisor/payment_profiles'
      : userRole === UserRoleName.Collector
        ? '/collector/payment_profiles'
        : userRole === UserRoleName.Admin ||
            userRole === UserRoleName.SuperAdmin ||
            userRole === UserRoleName.OrganizationAdmin
          ? '/admin/payment_profiles'
          : '/payment_profiles';
  const { data } = await client.post(path, payload);

  return data;
};
